export default "__VITE_ASSET__DwrjUTlh__"